import { Component, inject, OnInit } from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import { Articoli } from 'src/app/models/articoli';
import { Dipendente } from 'src/app/models/dipendente';
import { TabellaStatisticheModel } from 'src/app/models/tabella-statistiche';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import moment from 'moment';
import { CustomStore } from 'devextreme/common/data';
import {
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoScrollingComponent,
  DxoSummaryComponent,
} from 'devextreme-angular/ui/nested';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";



@Component({
  selector: 'app-articoli-statistiche',
  templateUrl: './articoli-statistiche.component.html',
  styleUrls: ['./articoli-statistiche.component.scss'],
  imports: [
    DxLookupComponent,
    DxDateBoxComponent,
    DxButtonComponent,
    DxLoadPanelComponent,
    DxDataGridComponent,
    DxoExportComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoScrollingComponent,
    DxTemplateDirective,
    DxoSummaryComponent,
  ],
  standalone: true,
})
export class ArticoliStatisticheComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private articoliService = inject(ArticoliService);
  private dipendentiService = inject(DipendentiService);
  private movimentiArticoliService = inject(MovimentoArticoliService);

  listArticoli: Articoli[] = [];
  listDipendenti: Dipendente[] = [];
  datiTabella: TabellaStatisticheModel = new TabellaStatisticheModel();
  idArticoloScelto: number = 0;
  visibleLoadPanel: boolean = false;
  daData: Date = new Date();
  aData: Date = new Date();
  listColumns: any[] = [];
  dataSource: any;
  totalSummaryItems: any[] = [];

  ngOnInit(): void {
    this.loadLookUp();
    this.daData = new Date(new Date().setMonth(new Date().getMonth() - 1));
  }

  loadLookUp() {
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = res.filter(x => x.attivo == true);
      }
    });

    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res;
      },
    });
  }

  loadConsegneArticolo() {
    this.visibleLoadPanel = true;
    this.movimentiArticoliService
      .generaDatiTabellaStatistiche(
        this.idArticoloScelto,
        this.daData,
        this.aData,
      )
      .subscribe({
        next: (res) => {
          this.datiTabella = res;
          this.visibleLoadPanel = false;
          this.caricaColonne();
          this.caricaDataSource();
        },
        error: (err) => {
          this.visibleLoadPanel = false;
          if (err?.error?.title) {
            notificaMessaggio(err.error.title, 'error');
          } else {
            notificaMessaggio('Errore recupero lista consegne', 'error');
          }
        },
      });
  }

  displayArticoloExpr(item: Articoli): string {
    if (!item) {
      return '';
    }
    return item.codice + ' - ' + item.descrizione;
  }

  cercaConsegne() {
    if (this.idArticoloScelto <= 0) {
      notificaMessaggio('Selezionare un articolo dalla lista', 'warning');
      return;
    }
    this.loadConsegneArticolo();
  }

  caricaColonne() {
    this.listColumns = this.datiTabella.headers.map((item, index) => {
      let newItem: any = {};
      if (moment(item.nomeCampo).isValid()) {
        newItem.cellTemplate = 'giornoFasciaTemplate';

        newItem.allowFiltering = false;
        newItem.allowHeaderFiltering = false;
        newItem.width = '50';
      } else {
        switch (item.nomeCampo) {
          case 'nominativo':
            newItem.width = '200';
            newItem.fixed = true;
            newItem.allowSearch = true;
            break;
          case 'mediaGg':
            newItem.width = '100';
            newItem.fixed = true;
            newItem.allowSearch = false;
            newItem.allowFiltering = false;
            newItem.allowHeaderFiltering = false;
            newItem.format = "#0.00";
            
            this.totalSummaryItems = [];
            this.totalSummaryItems.push({
              column: newItem.dataField ?? 'mediaGg', 
              summaryType: 'avg',
              valueFormat: '#0.00', 
              displayFormat: 'Media: {0}', 
            });

            break;
          case 'idDipendente':
            newItem.visible = false;
            break;
        }
      }
      if (item.tipo) {
        newItem.dataType = item.tipo;
      }
      if (item.formato) {
        newItem.format = item.formato;
      }
      newItem.dataField = item.nomeCampo;
      newItem.fixedPosition = 'left';
      newItem.alignment = 'center';
      if (item.caption) {
        newItem.caption = item.caption;
      }

      return newItem;
    });
  }

  sortByLookup(data: any) {
    const column = this as any;
    const value = column.calculateCellValue(data);
    let ret = column.lookup.calculateCellValue(value);
    return ret;
  }

  caricaDataSource() {
    this.dataSource = new CustomStore({
      key: 'idDipendente',
      load: (loadOptions) => {
        return this.datiTabella.dati;
      },
    });
  }

  onExporting(e: any) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Movimento Magazzino');
  
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
  
        customizeCell: ({ gridCell, excelCell } : any) => {
          if (!gridCell) return;
          if (gridCell.rowType !== 'data') return;
          if (moment(gridCell.column?.dataField).isValid()) {
            const v = Boolean(gridCell.value);
  
            if (v) {
              excelCell.value = "X";
            }
            else{
              excelCell.value='';
            }
  
            excelCell.alignment = { horizontal: 'center' };
          }
        },
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer: any) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            'Movimento_Magazzino.xlsx',
          );
        });
      });
  
      e.cancel = true;
    }
}
